var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDangerWhite = function SvgDangerWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M31.718 26.63 17.68 3.345a1.96 1.96 0 0 0-3.358 0L.28 26.63a1.96 1.96 0 0 0 1.68 2.973h28.078a1.96 1.96 0 0 0 1.68-2.973M16.01 10.451c.807 0 1.489.455 1.489 1.26 0 2.461-.29 5.996-.29 8.457 0 .64-.702.91-1.199.91-.661 0-1.22-.27-1.22-.91 0-2.46-.289-5.996-.289-8.456 0-.806.662-1.261 1.51-1.261zm.021 15.237c-.91 0-1.592-.745-1.592-1.592a1.58 1.58 0 0 1 1.592-1.592c.848 0 1.571.723 1.571 1.592 0 .847-.723 1.592-1.57 1.592z"
  })));
};
export default SvgDangerWhite;